import { z } from 'zod';
/** EU AI Act Annex III aligned rule domain values. */
export const RULE_DOMAINS = [
    'biometrics', 'critical_infrastructure', 'education', 'employment',
    'essential_services', 'law_enforcement', 'migration_border',
    'justice_democratic', 'healthcare', 'finance', 'legal',
    'government', 'defense', 'general_purpose',
    // V117-4-2: US state AI law (companion / conversational chatbots, synthetic-media provenance,
    // comprehensive privacy acts, pricing and advertising).
    'consumer_chatbots', 'content_provenance', 'consumer_privacy', 'consumer_commerce',
];
export const ruleDomainSchema = z.array(z.enum(RULE_DOMAINS)).default([]);
export const RULE_DOMAIN_LABELS = {
    biometrics: 'Biometrics & Identification',
    critical_infrastructure: 'Critical Infrastructure',
    education: 'Education & Training',
    employment: 'Employment & Workers',
    essential_services: 'Essential Services',
    law_enforcement: 'Law Enforcement',
    migration_border: 'Migration & Border Control',
    justice_democratic: 'Justice & Democratic Processes',
    healthcare: 'Healthcare',
    finance: 'Finance & Insurance',
    legal: 'Legal Services',
    government: 'Government & Public Administration',
    defense: 'Defense & National Security',
    general_purpose: 'General Purpose AI',
    consumer_chatbots: 'Consumer & Companion Chatbots',
    content_provenance: 'Content Provenance & Synthetic Media',
    consumer_privacy: 'Consumer Data & Privacy',
    consumer_commerce: 'Pricing & Advertising',
};
//# sourceMappingURL=rule-domains.js.map